/* eslint-disable @typescript-eslint/naming-convention */
export const environment = {
  fwpb: true,
  useSentry: true,
  production: true,
  baseWSUrl: 'wss://cb-wsproxy.inspireprojekt.de',
  fiwareUrl: 'https://cb.inspireprojekt.de',
  timeSeriesDbUrl: 'https://tsdb.inspireprojekt.de/',
  auth_config: {
    client_id: '74b42793-aa4c-434e-a00e-6355788885e3', // orion client id
    server_host: 'https://idm.inspireprojekt.de',
    redirect_url: 'appauth://callback',
    end_session_redirect_url: 'appauth://endsession',
    pkce: false,
    scopes: 'permanent',
  },
  inspireSSPUrl: 'https://app-ssp.inspireprojekt.de',
  osmServer: null, //'https://osm.inspireprojekt.de'
  sentryDSN: 'https://c71ff0dbdd684accbaaf04b7fef2b620@feedback.safetyinnovation.center/3',
  roadWorkService: 'https://api.safety-base.eu/v2/didoz/hub/v2/geo',
  roadServiceKey: '41cfc61d69fe4bba83a90744f93d2f9f',
  paderbornRoadworkArcGisFeatureService: 'https://utility.arcgis.com/usrsvcs/servers/41cfc61d69fe4bba83a90744f93d2f9f/rest/services/secure/SPB_Baustellenapp/FeatureServer/',
  roadworkLayersPBIndices: [12, 10] // 12 is the polygon, 10 is the triangle point
};
